export default __webpack_public_path__ + "static/media/sports_bottom.c4866da9.svg";